import gsx from '../../../styles'

const styles = {

  faqsContainer: {
    backgroundColor: 'background.default',
    marginTop: 0,
    py: 1,
  },

  faqCategory: {
    pb: 2,
  },
  showTitle: {
    pb: { xs: 2, md: 0 },
    textAlign: 'center',
    marginBottom: 2,
    marginTop: { xs: 3, md: 6 },
  },

  categoryTitle: {
    mb: 2,
  },

  showMore: {
    mt: 2,
    marginX: 'auto',
    textAlign: 'center',
  },

  showMoreLink: {
    display: 'block',
  },

  contact: {
    background: 'transparent',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    paddingY: 3,
    paddingX: 2,

    '& .MuiBox-root > .MuiGrid-container': {
      '& .MuiGrid2-root': {
        maxWidth: { lg: '50%!important' },
      },
    },
  },

  googleReviewsContainer: {
    '& > .MuiGrid-container': {
      ...gsx.googleReviewsContainer,
      marginTop: 2,
      marginBottom: 6,
    },
  },
}

export default styles
